import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { router } from './app.routes';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/auth.service';
import { StatsModule } from './modules/stats/stats.module';
import { HelpModule } from './modules/help/help.module';
import { AuthModule } from './modules/auth/auth.module';
import { PaymentModule } from './modules/payment/payment.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SessionsModule } from './modules/sessions/sessions.module';
import { SideMenuComponent } from './modules/sidemenu/sidemenu.component';
import { linksPipe } from './modules/sidemenu/sidemenu.pipe';
import { ModalsModule } from './modules/modals/modals.module';
import { TopnavbarComponent } from './modules/topnavbar/topnavbar.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { CacheableTranslateHttpLoader } from './providers/translation.http.loader';
import { Translation } from './providers/translation';
import { SearchModule } from './modules/search/search.module';
import { Topbar } from './providers/topbar';
import { environment as config } from '../environments/environment';
import { ErrorModule } from './modules/error/error.module';
import { ThemeModule } from './theme/theme.module';
import { ThemeService } from './theme/theme.service';
import { ChannelModule } from './modules/channel/channel.module';

export function httpLoaderFactory(http: HttpClient) {
  const api = `${config.translations.baseUrl}/apps/bo.selfservice.v1.1.text/translations/`;
  return new CacheableTranslateHttpLoader(http, api, '');
}

@NgModule({
  declarations: [AppComponent, SideMenuComponent, TopnavbarComponent, linksPipe],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    HttpModule,
    AuthModule,
    PaymentModule,
    StatsModule,
    HelpModule,
    SessionsModule,
    SearchModule,
    ErrorModule,
    ModalsModule,
    ThemeModule,
    ChannelModule,
    router
  ],
  providers: [Translation, Topbar, AuthService, ThemeService],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts